import mounted from './attrs/mounted'
import data from './attrs/data'
import methods from './attrs/methods'
import watch from './attrs/watch'
import Rating from 'vue-star-rating'

export default {
    name: 'PendingSatisfactionSurveys',
    mounted,
    data,
    methods,
    watch,
    components: {
        Rating
    }
}
